type StopAudio = () => void;

const decodeBase64 = (base64: string): ArrayBuffer => {
	const binary = atob(base64);
	const encodedAudio = new ArrayBuffer(binary.length);
	const bytes = new Uint8Array(encodedAudio);
	for (let index = 0; index < binary.length; index++) {
		bytes[index] = binary.charCodeAt(index);
	}
	return encodedAudio;
};

/**
 * Plays encoded audio bytes without creating a media URL. This keeps playback independent of the
 * consuming product's static-asset loaders and `media-src` Content Security Policy.
 */
export const playEncodedAudio = async (base64: string, volume: number): Promise<StopAudio> => {
	let audioContext: AudioContext | null = null;
	try {
		const context = new AudioContext();
		audioContext = context;
		const audioBuffer = await context.decodeAudioData(decodeBase64(base64));
		const source = context.createBufferSource();
		const gain = context.createGain();
		source.buffer = audioBuffer;
		gain.gain.value = volume;
		source.connect(gain);
		gain.connect(context.destination);
		source.start();

		let hasStopped = false;
		return () => {
			if (hasStopped) {
				return;
			}
			hasStopped = true;
			try {
				source.stop();
			} catch {
				// The source may already have finished naturally.
			}
			void context.close().catch(() => undefined);
		};
	} catch {
		void audioContext?.close().catch(() => undefined);
		return () => undefined;
	}
};
